import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import pending from './pending';
import all from './all';

const IbanNumbers = ({match}) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/pending`}/>
      <Route path={`${match.url}/pending`} component={pending}/>
      <Route path={`${match.url}/all`} component={all}/>
      <Redirect to="/error"/>
    </Switch>
  </div>
);
export default IbanNumbers;
